// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var Js_json = require("@rescript/std/lib/js/js_json.js");
var Belt_Result = require("@rescript/std/lib/js/belt_Result.js");

function nullableToJson(encoder, $$null$1) {
  if ($$null$1 == null) {
    return null;
  } else {
    return Curry._1(encoder, $$null$1);
  }
}

function nullableFromJson(decoder, json) {
  var match = Js_json.decodeNull(json);
  if (match !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: null
          };
  } else {
    return Belt_Result.map(Curry._1(decoder, json), (function (v) {
                  return v;
                }));
  }
}

var t_encode = nullableToJson;

var t_decode = nullableFromJson;

exports.nullableToJson = nullableToJson;
exports.nullableFromJson = nullableFromJson;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
/* No side effect */
